import {
  SidePanel,
  ButtonPrimary,
  ButtonSecondary,
  PermissionEnum,
  PermissionDenied,
} from '@ui/src';
import GroupFrom from '../../../components/charts/charts-panel/charts-panel-group';
import useGroupCreate from './hooks/use-create';

import cn from '../styles.module.css';

const GroupFormHOC = (): React.JSX.Element => {
  const {
    typeOptions,
    activePermissions,
    requestInProgress,
    description,
    group,
    control,
    errors,
    onSubmit,
    categories,
    groups,
    panelIsOpen,
    handleClose,
    categoryId,
  } = useGroupCreate();

  let content;

  if (
    !activePermissions?.includes(PermissionEnum.ACCOUNTS_CHART_ADD_GROUP_ACTION)
  ) {
    content = <PermissionDenied />;
  } else {
    content = (
      <GroupFrom
        category={categories.find((category) => category.id === categoryId)}
        control={control}
        name={description}
        group={group}
        typeOptions={typeOptions}
        errors={errors}
        groupNumber={groups?.length.toString()}
      />
    );
  }

  return (
    <SidePanel
      closeOnClickOutside={false}
      isOpen={panelIsOpen}
      onClose={handleClose}
      parent={document.getElementById('chart-modal') as HTMLElement}
      title="Group Add"
      className={cn.chartSidePanel}
      sidepanelExpandedKey="charts-group-create"
      footer={
        <>
          {activePermissions?.includes(
            PermissionEnum.ACCOUNTS_CHART_ADD_GROUP_ACTION,
          ) && (
            <ButtonPrimary
              text={requestInProgress ? 'Loading...' : 'Save'}
              disabled={requestInProgress}
              onClick={onSubmit}
            />
          )}
          <ButtonSecondary text="Close" onClick={handleClose} />
        </>
      }
    >
      {content}
    </SidePanel>
  );
};

export default GroupFormHOC;
